/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { makeStyles, tokens } from "../../packages/fluent9";

/**
 * Gets the styles for the TeamTag component.
 * @returns The styles for the TeamTag component.
 */
export const useStyles = makeStyles({
    teamTag: {
        backgroundColor: tokens.colorNeutralBackground2Selected
    }
});
